import CalendarAltRegular from '@alefeducation/ui-elements-library-icons/lib/components/Icons/CalendarAltRegular';
import { Text } from '@alefeducation/ui-elements-library-core/lib/Text';
import React from 'react';
import { StyledDateButton } from './DatePicker.styled';

const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const getOrdinal = (n: number) => {
  switch (n) {
    case 1:
    case 21:
    case 31:
      return 'st';
    case 2:
    case 22:
      return 'nd';
    case 3:
    case 23:
      return 'rd';
    default:
      return 'th';
  }
};

export const getDateString = (date: Date) => {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  return `${day}${getOrdinal(day)} ${monthNames[month]}, ${year}`;
};

export type DatePickerButtonProps = {
  id?: string;
  value: Date | string;
  onClick?: () => void;
  ariaChecked?: boolean;
  disabled?: boolean;
};

export const DatePickerButton = ({
  id,
  value,
  onClick,
  ariaChecked,
  disabled,
}: DatePickerButtonProps) => {
  return (
    <StyledDateButton
      data-testid="test-date-button"
      variant="secondary"
      onClick={onClick}
      id={id}
      role="checkbox"
      aria-checked={ariaChecked}
      disabled={disabled}
    >
      <CalendarAltRegular color="primary.40" />
      <Text variant="body-large" weight="light" color="primary.100">
        {typeof value === 'string' ? value : getDateString(value)}
      </Text>
    </StyledDateButton>
  );
};
